
const FamilyTopNavbar = ({ mainMenu }) => {

  return (
    <div
      className="py-3 px-6 flex align-items-center justify-content-between"
      style={{
        background: "rgba(255, 255, 255, 1)",
        borderBottom: "1px solid #dbe3f1",
        boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
        backdropFilter: "blur(8px)",
      }}
    >
      <img src="/images/mealogo.png" alt="MEA" height={50} />
      <div className="flex gap-2">
        {mainMenu}
      </div>
    </div>
  )
}

export default FamilyTopNavbar;